import React, { ReactNode } from "react";

import { IgButton } from "@intelligems/ig-theme";

import { useConfiguration } from "../../api/configurations/use-configuration";

interface TestPilotButtonProps {
  onClick: () => void;
  dark?: boolean;
  text?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  hasAccess?: boolean;
}

export const TestPilotButton = ({
  onClick,
  dark,
  text,
  loading,
  disabled,
  hasAccess,
}: TestPilotButtonProps) => {
  const enableAi = useConfiguration<boolean>("enable_ai")?.value;

  const _hasAccess = hasAccess || enableAi;

  if (!_hasAccess) {
    return null;
  }

  return (
    <IgButton
      disabled={disabled}
      loading={loading}
      variant={dark ? undefined : "contained"}
      igVariant={dark ? "testPilotBlue" : undefined}
      onClick={onClick}
    >
      ✨ {text || "TestPilot"}
    </IgButton>
  );
};
